import { render, staticRenderFns } from "./topbar-user-menu.vue?vue&type=template&id=63eef651&scoped=true&"
import script from "./topbar-user-menu.vue?vue&type=script&lang=js&"
export * from "./topbar-user-menu.vue?vue&type=script&lang=js&"
import style0 from "./topbar-user-menu.vue?vue&type=style&index=0&id=63eef651&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63eef651",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VDivider,VList,VListItem,VListItemIcon,VListItemTitle,VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63eef651')) {
      api.createRecord('63eef651', component.options)
    } else {
      api.reload('63eef651', component.options)
    }
    module.hot.accept("./topbar-user-menu.vue?vue&type=template&id=63eef651&scoped=true&", function () {
      api.rerender('63eef651', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/navegacao-v2/components/topbar-user-menu.vue"
export default component.exports